<template>
  <v-dialog
    v-model="active"
    width="20%"
  >
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Editar folio
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div
          class="text-subtitle-1 mb-4 font-weight-bold"
          align="center"
        >
          Folio actual: {{ expediente.folio }}
        </div>
        <v-text-field
          v-model="folio"
          label="Nuevo folio"
          rounded
          filled
          dense
          color="secondary"
          background-color="primary"
        />
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="loading || folio === ''"
          @click="guardarFolio"
        >
          Asignar folio
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    expediente: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      folio: '',
      loading: false,
    };
  },

  methods: {
    ...mapActions('expediente', ['updateFolioExpediente', 'fetchExpedientes']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async guardarFolio() {
      this.loading = true;
      await this.updateFolioExpediente({
        idPersonal: this.expediente.Personal.idPersonal,
        id: this.expediente.idExpediente,
        folio: this.folio,
      });
      await this.fetchExpedientes();

      this.SET_SNACKBAR_MESSAGE('Folio guardado.');
      this.closeDialog();
    },

    closeDialog() {
      this.folio = '';
      this.loading = false;
      this.$emit('close');
    },
  },
};
</script>
